import React from "react";
import skin from "../assets/screenshot.png";

const LoggedOutFrame = () => {
  return (
    <>
      <div className="absolute top-0 left-0 h-full w-full flex justify-center items-center select-none">
        <div className="flex flex-col max-w-[600px] w-full min-h-[400px] border-orange-600 border-2 rounded-xl">
          <div className="bg-[#FFA600] bg-opacity-10 min-h-[70px] flex justify-center items-center border-orange-600 border-b-2">
            <h1 className="font-[Agbalumo] drop-shadow-[0_2px_2px_#684503] text-[#FF902F] text-3xl">
              Disconnected
            </h1>
          </div>
          <div className="flex items-center text-center h-full w-full">
            <p className="font-semibold font-sans text-base flex items-center text-[#FF902F] text-2xl px-5">
              Please use /experience ingame to get a working Webclient!
            </p>
            <div className="flex justify-end gap-12 w-full items-end h-full">
              <img src={skin} height={"100%"} className="rounded-xl"></img>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoggedOutFrame;
